export enum VehicleDriverEvaluationStatusType {
  NOT_AVAILABLE = 'NotAvailable',
  AVAILABLE = 'Available',
  UNABLE_EVALUATION = 'UnableEvaluation',
}
